import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4d45a990"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  class: "status-center",
  "data-test": "unread"
}

import { computed, ref } from "vue";
import { Tooltip } from "uiv";
import timeAgo from "../../services/utilities/time-ago";
import { NotificationApiModel } from "../../api-models";
import NotificationImage from "./notification-image.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification-item',
  props: {
    notification: {}
  },
  emits: ["update-status"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showTooltip = ref(false);

const tooltipText = computed(() => {
  if (props.notification.status === "Read") {
    return "Mark as unread";
  }

  return "Mark as read";
});

const appendTimeAgo = (notification: NotificationApiModel): string => {
  const closingTagIndex = notification.message.lastIndexOf("</p>");
  if (closingTagIndex === -1) {
    return notification.message;
  }
  const messageStart = notification.message.substring(0, closingTagIndex);
  const messageEnd = notification.message.substring(closingTagIndex);
  return `${messageStart} <span class="time-ago">&nbsp;${timeAgo(
    notification.createdDate,
  )}</span>${messageEnd}`;
};

const updateStatus = (notification: NotificationApiModel) => {
  const newStatus = notification.status === "Read" ? "Unread" : "Read";
  emit("update-status", notification, newStatus);
};

const handleClick = (notification: NotificationApiModel) => {
  if (notification.notificationLink) {
    const url = new URL(notification.notificationLink);
    const params = new URLSearchParams(url.search);

    // Set relevant teamId if it exists
    if (notification.teamId) {
      params.set("teamId", notification.teamId);
    }

    if (notification.status !== "Read") {
      updateStatus(props.notification);
    }

    url.search = params.toString();
    window.location.href = url.toString().replace("5000", "8080");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    tabindex: "0",
    href: _ctx.notification.notificationLink,
    "data-test": "user-notification",
    class: "notification-item",
    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (handleClick(_ctx.notification)), ["prevent"]))
  }, [
    _createVNode(NotificationImage, { notification: _ctx.notification }, null, 8, ["notification"]),
    _createElementVNode("div", null, [
      _createElementVNode("span", {
        innerHTML: appendTimeAgo(_ctx.notification),
        class: "message-text",
        "data-test": "notification-message"
      }, null, 8, _hoisted_2)
    ]),
    (_openBlock(), _createBlock(_unref(Tooltip), {
      modelValue: showTooltip.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTooltip).value = $event)),
      text: tooltipText.value,
      target: `#tooltip-${_ctx.notification.id}`,
      key: _ctx.notification.id,
      "data-test": "notification-tooltip",
      trigger: "manual"
    }, null, 8, ["modelValue", "text", "target"])),
    _createElementVNode("button", {
      id: `tooltip-${_ctx.notification.id}`,
      class: "status",
      type: "button",
      onMouseover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showTooltip.value = true), ["stop","prevent"])),
      onMouseleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showTooltip.value = false), ["stop","prevent"])),
      onFocus: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showTooltip.value = true), ["stop","prevent"])),
      onBlur: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showTooltip.value = false), ["stop","prevent"])),
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (updateStatus(_ctx.notification)), ["stop","prevent"])),
      "data-test": "status-update-button"
    }, [
      _withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [
        [_vShow, _ctx.notification.status === 'Unread']
      ])
    ], 40, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})